import * as React from "react";
import { forwardRef } from "react";
const SvgEmojiNeutral = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "64px", height: "64px", viewBox: "0 0 64 64", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", { id: "linear0", gradientUnits: "userSpaceOnUse", x1: -583.125, y1: 760.321, x2: -583.125, y2: 698.321, gradientTransform: "matrix(1,0,0,-1,615.125,761.625)" }, /* @__PURE__ */ React.createElement("stop", { offset: 0, style: {
  stopColor: "rgb(100%,88.235294%,0%)",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 1, style: {
  stopColor: "rgb(97.647059%,53.72549%,0%)",
  stopOpacity: 1
} })), /* @__PURE__ */ React.createElement("linearGradient", { id: "linear1", gradientUnits: "userSpaceOnUse", x1: -572.125, y1: 733.9, x2: -572.125, y2: 743.432, gradientTransform: "matrix(1,0,0,-1,615.125,761.625)" }, /* @__PURE__ */ React.createElement("stop", { offset: 5e-3, style: {
  stopColor: "rgb(25.490196%,30.196078%,30.196078%)",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.206, style: {
  stopColor: "rgb(22.745098%,27.058824%,27.058824%)",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.522, style: {
  stopColor: "rgb(15.294118%,18.039216%,18.039216%)",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.914, style: {
  stopColor: "rgb(3.137255%,3.529412%,3.529412%)",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 1, style: {
  stopColor: "rgb(0%,0%,0%)",
  stopOpacity: 1
} })), /* @__PURE__ */ React.createElement("linearGradient", { id: "linear2", gradientUnits: "userSpaceOnUse", x1: -594.125, y1: 733.769, x2: -594.125, y2: 742.75, gradientTransform: "matrix(1,0,0,-1,615.125,761.625)" }, /* @__PURE__ */ React.createElement("stop", { offset: 5e-3, style: {
  stopColor: "rgb(25.490196%,30.196078%,30.196078%)",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.206, style: {
  stopColor: "rgb(22.745098%,27.058824%,27.058824%)",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.522, style: {
  stopColor: "rgb(15.294118%,18.039216%,18.039216%)",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.914, style: {
  stopColor: "rgb(3.137255%,3.529412%,3.529412%)",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 1, style: {
  stopColor: "rgb(0%,0%,0%)",
  stopOpacity: 1
} }))), /* @__PURE__ */ React.createElement("g", { id: "surface1" }, /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "url(#linear0)"
}, d: "M 32 63 C 4.300781 63 0.960938 39 1 33 L 1 31 C 0.960938 25 4.300781 1 32 1 C 59.699219 1 63.039062 25 63 31 L 63 33 C 63.039062 39 59.699219 63 32 63 Z M 32 63 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "url(#linear1)"
}, d: "M 46 23 C 46 20.238281 44.65625 18 43 18 C 41.34375 18 40 20.238281 40 23 C 40 25.761719 41.34375 28 43 28 C 44.65625 28 46 25.761719 46 23 Z M 46 23 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "url(#linear2)"
}, d: "M 24 23 C 24 20.238281 22.65625 18 21 18 C 19.34375 18 18 20.238281 18 23 C 18 25.761719 19.34375 28 21 28 C 22.65625 28 24 25.761719 24 23 Z M 24 23 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(11.372549%,11.372549%,10.588235%)",
  fillOpacity: 1
}, d: "M 55.898438 12.601562 C 55.398438 11.9375 54.863281 11.289062 54.3125 10.675781 L 55.789062 9.324219 C 56.386719 9.988281 56.960938 10.6875 57.5 11.398438 Z M 55.898438 12.601562 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(11.372549%,11.372549%,10.588235%)",
  fillOpacity: 1
}, d: "M 7.3125 53.636719 C 0.125 44.914062 -0.0117188 34.1875 0 33 L 0 31 C -0.0390625 26.050781 1.824219 15.726562 9.023438 8.476562 C 14.613281 2.851562 22.335938 0 32 0 C 40.914062 0 48.199219 2.4375 53.675781 7.25 L 52.351562 8.75 C 47.261719 4.273438 40.414062 2 32 2 C 22.898438 2 15.636719 4.648438 10.4375 9.886719 C 3.710938 16.664062 1.976562 26.335938 2 30.988281 L 2 33 C 1.976562 37.074219 3.386719 45.726562 8.863281 52.363281 Z M 7.3125 53.636719 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(11.372549%,11.372549%,10.588235%)",
  fillOpacity: 1
}, d: "M 32 64 C 22.5 64 14.863281 61.238281 9.300781 55.800781 L 10.699219 54.375 C 15.875 59.4375 23.050781 62 32 62 C 41.101562 62 48.363281 59.351562 53.5625 54.113281 C 60.289062 47.335938 62.039062 37.664062 62 33.011719 L 62 30.886719 C 61.835938 25.113281 60.1875 19.476562 57.210938 14.523438 L 58.914062 13.476562 C 62.085938 18.738281 63.835938 24.75 64 30.886719 L 64 33 C 64.039062 37.949219 62.175781 48.273438 54.976562 55.523438 C 49.386719 61.148438 41.664062 64 32 64 Z M 32 64 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(11.372549%,11.372549%,10.588235%)",
  fillOpacity: 1
}, d: "M 43 29 C 40.761719 29 39 26.363281 39 23 C 39 19.636719 40.761719 17 43 17 C 45.238281 17 47 19.636719 47 23 C 47 26.363281 45.238281 29 43 29 Z M 43 19 C 42.050781 19 41 20.710938 41 23 C 41 25.289062 42.050781 27 43 27 C 43.949219 27 45 25.289062 45 23 C 45 20.710938 43.949219 19 43 19 Z M 43 19 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(11.372549%,11.372549%,10.588235%)",
  fillOpacity: 1
}, d: "M 21 29 C 18.761719 29 17 26.363281 17 23 C 17 19.636719 18.761719 17 21 17 C 23.238281 17 25 19.636719 25 23 C 25 26.363281 23.238281 29 21 29 Z M 21 19 C 20.050781 19 19 20.710938 19 23 C 19 25.289062 20.050781 27 21 27 C 21.949219 27 23 25.289062 23 23 C 23 20.710938 21.949219 19 21 19 Z M 21 19 " }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  strokeWidth: 15,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  stroke: "rgb(0%,0%,0%)",
  strokeOpacity: 1,
  strokeMiterlimit: 10
}, d: "M 136 367 L 376 367 ", transform: "matrix(0.125,0,0,0.125,0,0)" })));
const ForwardRef = forwardRef(SvgEmojiNeutral);
export default ForwardRef;
